import React from "react";
import Link from "@/shared/lib/router/link";
import { useRouter } from "@/shared/lib/router/router";
import { SidebarMenuSub, SidebarMenuSubButton, SidebarMenuSubItem, useSidebar } from "@/shared/ui/kit/sidebar";
import { useProject } from "@/entities/project/model/projectContext";
import ProjectContextCard from "./ProjectContextCard";

/**
 * Navegação de Obras na sidebar global.
 * - Sem obra selecionada: tabs principais da listagem (Geral / Lista).
 * - Com obra selecionada: contexto + atalho para o Hub. A navegação por área
 *   passou para o rail do workspace (ProjectWorkspaceLayout).
 */
export default function ProjectSidebarMenu() {
    const router = useRouter();
    const { currentProjectName } = useProject();
    const { setOpenMobile } = useSidebar();

    const projectId = router.query.projectId as string | undefined;
    const tab = router.query.tab as string | undefined;
    const onStock = router.asPath.includes("/stock");

    const links = projectId
        ? [
            { href: `/project/${projectId}?tab=hub`, label: "Abrir obra (Hub)", active: !onStock && (tab === "hub" || !tab) },
            { href: "/projects?tab=list", label: "‹ Lista de obras", active: false },
        ]
        : [
            { href: "/projects?tab=general", label: "Geral", active: tab === "general" || !tab },
            { href: "/projects?tab=list", label: "Lista de Obras", active: tab === "list" },
        ];

    return (
        <>
            {projectId && <ProjectContextCard projectName={currentProjectName} />}
            <SidebarMenuSub>
                {links.map((link) => (
                    <SidebarMenuSubItem key={link.label}>
                        <SidebarMenuSubButton asChild isActive={link.active}>
                            <Link href={link.href} onClick={() => setOpenMobile(false)}>
                                <span>{link.label}</span>
                            </Link>
                        </SidebarMenuSubButton>
                    </SidebarMenuSubItem>
                ))}
            </SidebarMenuSub>
        </>
    );
}
